import React from 'react';
import { Badge } from '../ui/badge';
import { Phone, MessageCircle, Mail, StickyNote } from 'lucide-react';
import { OrigenTag } from './leadOrigen';

const waLink = (tel) => `https://wa.me/${tel.replace(/\D/g, '')}`;

export const LeadCard = ({ lead, etapas, formatDate, onUpdateLead, onEditNotes }) => {
  const etapa = etapas.find((e) => e.value === (lead.etapa || 'nuevo')) || etapas[0];
  return (
    <article className="rounded-2xl border border-white/10 bg-slate-900/60 p-4 space-y-3" data-testid="admin-lead-card">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-semibold text-white truncate">{lead.nombre}</p>
          <p className="text-xs text-slate-400 truncate">{lead.tipo_seguro ? `${lead.tipo_seguro} · ` : ''}{formatDate(lead.fecha_suscripcion)}</p>
          <div className="mt-1"><OrigenTag origen={lead.origen} /></div>
        </div>
        <Badge className={`border-0 shrink-0 ${lead.estado === 'cancelado' ? 'bg-red-500/20 text-red-300' : 'bg-emerald-500/20 text-emerald-300'}`}>{lead.estado}</Badge>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <a href={`mailto:${lead.email}`} data-testid="lead-card-email" className="h-11 rounded-xl bg-white/5 hover:bg-white/10 flex items-center justify-center gap-1.5 text-xs text-slate-200 transition-colors"><Mail className="h-4 w-4" /> Email</a>
        {lead.telefono ? (
          <>
            <a href={`tel:${lead.telefono}`} data-testid="lead-card-call" className="h-11 rounded-xl bg-blue-600/20 hover:bg-blue-600/30 flex items-center justify-center gap-1.5 text-xs text-blue-200 transition-colors"><Phone className="h-4 w-4" /> Llamar</a>
            <a href={waLink(lead.telefono)} target="_blank" rel="noopener noreferrer" data-testid="lead-card-whatsapp" className="h-11 rounded-xl bg-[#25D366]/20 hover:bg-[#25D366]/30 flex items-center justify-center gap-1.5 text-xs text-emerald-200 transition-colors"><MessageCircle className="h-4 w-4" /> WhatsApp</a>
          </>
        ) : (
          <span className="col-span-2 h-11 rounded-xl bg-white/5 flex items-center justify-center text-xs text-slate-500">Sin teléfono</span>
        )}
      </div>
      <p className="text-xs text-slate-400 break-all">{lead.email}{lead.telefono ? ` · ${lead.telefono}` : ''}</p>

      <div className="flex items-center gap-2">
        <select
          data-testid="lead-card-etapa-select"
          value={lead.etapa || 'nuevo'}
          onChange={(e) => onUpdateLead(lead.id, { etapa: e.target.value })}
          className={`h-11 flex-1 px-3 rounded-xl border text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500/40 bg-slate-900 ${etapa.className}`}
        >
          {etapas.map((e) => <option key={e.value} value={e.value} className="bg-slate-900 text-white">{e.label}</option>)}
        </select>
        <button type="button" onClick={() => onEditNotes(lead)} data-testid="lead-card-notes-btn" className={`h-11 px-4 rounded-xl border border-white/10 flex items-center gap-1.5 text-sm hover:bg-white/10 transition-colors ${lead.notas ? 'text-amber-300' : 'text-slate-300'}`}>
          <StickyNote className="h-4 w-4" /> Notas
        </button>
      </div>
      {lead.notas && <p className="text-xs text-slate-300 bg-white/5 rounded-xl px-3 py-2 line-clamp-3" data-testid="lead-card-notes">{lead.notas}</p>}
    </article>
  );
};

export default LeadCard;
